export type CatalogSchedule = {
  id: number;
  from: string;
  to: string;
};

export type OperationSlot = {
  attributes: {
    from: string;
    to: string;
  };
};

export type ScheduleOption = {
  id: number;
  from: string;
  to: string;
  isAvailable: boolean;
};

const normalizeHour = (value: string): string => {
  const match = /^(\d{2}):(\d{2})(?::(\d{2}))?/.exec(value ?? '');

  return match ? `${match[1]}:${match[2]}:${match[3] ?? '00'}` : '';
};

/**
 * Casa cada horario que a praca oferece (operations) com o schedule de mesma
 * faixa no catalogo do services-api, de onde sai o scheduleId usado no
 * agendamento. O `to` faz parte da chave: a mesma hora de inicio pode existir
 * como slot de 1h e de 2h, e so a faixa inteira identifica o schedule certo.
 * Slot sem schedule correspondente e descartado - sem id nao ha como agendar.
 */
export const buildScheduleOptions = (
  operationSlots: OperationSlot[],
  catalog: CatalogSchedule[]
): ScheduleOption[] =>
  (operationSlots ?? [])
    .map((slot) => {
      const from = normalizeHour(slot?.attributes?.from);
      const to = normalizeHour(slot?.attributes?.to);

      if (!from || !to) return null;

      const schedule = (catalog ?? []).find(
        (item) => normalizeHour(item.from) === from && normalizeHour(item.to) === to
      );

      if (!schedule) return null;

      return { id: schedule.id, from, to, isAvailable: true };
    })
    .filter((option): option is ScheduleOption => option !== null)
    .sort((a, b) => a.from.localeCompare(b.from));
